import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

/** Thẻ "Đồ đang mượn" ở Hiệu suất của tôi. */
export function canReadMyLoans(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.EquipmentLoanReadSelf);
}

/** Trang "Đồ quá hạn" của người quản lý. */
export function canReadOverdueLoans(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.EquipmentLoanOverdueRead);
}
